export default (state) => state.authentication.userPermissions
